import { render, staticRenderFns } from "./FundsProducts.vue?vue&type=template&id=1c183044&scoped=true"
import script from "./FundsProducts.vue?vue&type=script&lang=ts&setup=true"
export * from "./FundsProducts.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./FundsProducts.vue?vue&type=style&index=0&id=1c183044&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c183044",
  null
  
)

export default component.exports